export enum PipelineView {
    Deal = 'deal',
    Class = 'class',
    KMatrix = 'kMatrix'
}
